/* eslint-disable indent */
import React from 'react';
import { BaseCard } from '../BaseCard';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
/**
 * @author Mochamad Riza Syarif<mochamad.riza@bvarta.com>
 * @copyright PT Bhumi Varta Tecnology
 * @param {Object} props
 * @param {Array<{label: string, value: number,color: string}>} props.data
 * @param {string} props.title
 * @param {React.CSSProperties} props.style
 * @param {boolean} props.isLoading
 */
export const CardSesResult = (props) => {
  const { title, data, style, isLoading } = props;

  const ses_new =
    data?.map((item) => ({
      name: item.label,
      y: item.value,
      color: item.color,
      borderWidth: 0,
      borderColor: 'transparent',
      dataLabels: {
        enabled: data.length === 0 || item.value === 0 ? false : true,
      },
    })) ?? [];

  const percentageValue = ({ percentage }) => {
    if (percentage) {
      if (percentage === 100) {
        return percentage;
      }
      return percentage.toFixed(2);
    }
    return 0;
  };

  const chartOptions = {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      plotShadow: false,
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      spacingTop: 0,
      spacingLeft: 0,
      spacingRight: 0,
      spacingBottom: 0,
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      enabled: false,
      point: {
        valueSuffix: '%',
      },
    },
    title: {
      text: '',
    },
    tooltip: {
      useHTML: true,
      borderColor: 'transparent',
      backgroundColor: '#fff',
      borderRadius: 8,
      headerFormat: '',
      formatter() {
        let point = this?.point;
        return `
        <div style="
          display:flex; 
          align-items:center; 
          text-align:center; 
          gap:0.25rem;">
          <span>${point?.name}:</span>
          <span>
            <b>
              ${point?.y}% 
              (${percentageValue({ percentage: point.percentage })}%)
            </b>
          </span>
        <div>
        `;
      },
      shadow: {
        color: '#000',
        offsetX: 0,
        offsetY: 0.1,
        opacity: 0.2,
        width: 2,
      },
    },
    plotOptions: {
      pie: {
        cursor: 'pointer',
        innerSize: '55%',
        colorByPoint: true,
        allowPointSelect: true,
        showInLegend: true,
        states: {
          inactive: {
            opacity: 1,
          },
          hover: {
            shadow: false,
            halo: {
              enabled: false,
              opacity: 0,
            },
          },
        },
        dataLabels: {
          enabled: true,
          useHTML: true,
          distance: -38,
          formatter: function () {
            const point = this?.point;
            return `
            <div style="
                display:flex; 
                align-items:center; 
                text-align:center; 
                flex-direction:column; 
                color:#fff;">
                <span style="font-size:0.75rem; font-weight:bold;">
                  ${point?.y}%
                </span>
                <span style="font-size:0.75rem; font-weight:400;">
                (${percentageValue({ percentage: point.percentage })}%)
                </span>
            </div>`;
          },
          style: {
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
          },
        },
      },
    },
    legend: {
      align: 'right',
      layout: 'vertical',
      verticalAlign: 'middle',
      enable: true,
      itemMarginBottom: 8,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 5,
    },
    series: [
      {
        type: 'pie',
        name: 'SES',
        data: ses_new,
      },
    ],
  };
  return (
    <div className='shared CardSes' style={style}>
      <BaseCard
        isLoading={isLoading}
        title={title ?? 'Social Economic Status (SES)'}
        withPadding={true}
      >
        <div className='CardSes__wrapper'>
          {data?.length > 0 && (
            <div className='CardSes__wrapper__chart'>
              <HighchartsReact
                allowChartUpdate={true}
                highcharts={Highcharts}
                options={{ ...chartOptions }}
              />
            </div>
          )}
        </div>
      </BaseCard>
    </div>
  );
};
